import React from 'react'



export default function BuildGas(props) {

    const [userClassDesc, setUserClassDesc] = React.useState("");
    const [discount, setDiscount] = React.useState(0);

    React.useEffect(() => {
        let gasRatesResult = props.values.gasRatesResult;

        if (
            gasRatesResult instanceof Object &&
            gasRatesResult.MyGasQuote.GasQuote instanceof Array
        ) {
            //  setRatesStatus(false)
            //set negative to absolute and set as discount variable
            setDiscount(30);
        }
        if (props.values.gasUserClass instanceof Array) {
            props.values.gasUserClass.map(function (item) {
            if (item.UserClassCode === props.values.gasUserCode) {
                setUserClassDesc(item.UserClassDescription);
            }
            });
        }
        }, [
        props.values.gasRatesResult,
        props.values.gasUserClass,
        props.values.gasUserCode,
    ]);

    const formatRates = (rates) => {
      if (props.noGst) {
        rates = rates * 1.15;
      }
      
      return parseFloat(rates).toFixed(3) + " ¢";
    };
    
    const formatDollarRates = (rates) => {
        return "$" + parseFloat(rates).toFixed(2);
    };

    const formatKey = (key) => {
        let k = key.replace(/([A-Z])/g, " $1").trim();
        return k;
    };

    const GasRates = () => {

        if (!props.values.gasRatesResult?.MyGasQuote) {
            return null;
        }
        

        const gasHtml = (
            <React.Fragment>
            {props.values.gasRatesResult.MyGasQuote.GasQuote.map(
              function (item, i) {
                return (
                  <React.Fragment>
                    {item.Rate > 0 && (
                      <tr className="tr-border-bottom">
                        <td style={{ paddingLeft: "0" }} className="gas-left">
                          {item.ContentDesc}
                        </td>
                        {/* <td>{item.ContentDesc === 'Fixed Daily Charges' ? formatRates(item.Rate-discount)+' /Day':formatRates(item.Rate)+' /kWh'}</td> */}
                        <td align="right" className="gas-right">
                          {item.ContentDesc === "Fixed Daily Charges"
                            ? formatRates(item.Rate + discount) + "/Day"
                            : formatRates(item.Rate) + "/kWh"}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              }
            )}
            <tr id="allEnergyDiscount" className="tr-border-bottom">
              <td
                align="left"
                style={{ paddingLeft: "0" }}
                className="summary-highlight gas-left"
              >
                All Energy Discount
              </td>
              <td align="right" className="summary-highlight gas-right gas-green">
                <strong>-{formatRates(discount) + " /Day"}</strong>
              </td>
            </tr>
          </React.Fragment>
          );
         
        return gasHtml;
    
    }
    
    return (
        <React.Fragment>
            <div className="MuiPaper-root MuiTableContainer-root MuiPaper-elevation1 MuiPaper-rounded gas-parent-wrapper">
                <table className="MuiTable-root jss58" aria-label="table" id="gas-service-table">
                    <tbody className="MuiTableBody-root jss60" style={{ border: "none" }}>
                        {GasRates()}
                    </tbody>
                </table>
                <table>
                  <tbody className="MuiTableBody-root jss60" style={{ border: "none" }}>
                    <tr className="tr-border-bottom">
                      <td align="left" className={`lpg-left ${props.noGst ? 'gst-green' : ''}`} style={{ paddingLeft: "0px" }}><strong>{props.noGst ? 'With GST' : 'With GST'}</strong></td>
                      <td align="right" className="lpg-right" style={{ textAlign: "right" }}>
                        <label className="service-checkbox">
                          <input
                              type="checkbox"
                              id="noGstCheckbox"
                              name="noGstCheckbox"
                              checked={props.noGst} // Use props.noGst
                              onChange={props.handleNoGstChange} // Use props.handleNoGstChange
                          />
                          <span className="checkmark"></span>
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="gasP" dangerouslySetInnerHTML={{__html: props.noGst ? props.values.GasRatesGstTableFootNote : props.values.GasRatesTableFootNote}}></div>
            </div>
        </React.Fragment>
      )
  }